import { toast } from '@webapp/components/Notification'
import { getMessageFromError } from '@webapp/core/utils/errors/getMessageFromError'
import { useProcurifyIntl } from '@webapp/hooks'
import { useUnlockAllCatalogItemsModel } from '@webapp/modules/purchasing/features/unlock-all-catalog-items/models'
import messages from './messages'

export const useUnlockAllCatalogItemsPresenter = () => {
  const { unlockAllCatalogItems, isLoading } = useUnlockAllCatalogItemsModel()
  const intl = useProcurifyIntl()

  const unlockAll = async (): Promise<void> => {
    try {
      await unlockAllCatalogItems()

      toast.success({
        title: intl.formatMessage(messages.successTitle),
        children: intl.formatMessage(messages.successMessage),
      })
    } catch (error) {
      toast.error({
        title: intl.formatMessage(messages.errorTitle),
        children:
          getMessageFromError(error) ||
          intl.formatMessage(messages.errorMessage),
      })

      // Re-throw so the consuming Feature Set owns the outcome (e.g. whether
      // its confirmation modal closes) — the toast above is this presenter's
      // whole error responsibility.
      throw error
    }
  }

  return {
    commands: {
      unlockAll,
    },
    states: {
      isSaving: isLoading,
    },
  }
}
